import React from "react";
import Keycloak from "keycloak-js";
import { useHistory } from "react-router-dom";
import { Keycloaktokens, User } from "../storage/store";
import ApiConfig from "../api/config";

const Login = () => {
  // Refer the keyclock doc for authentication
  let initOptions = {
    url: ApiConfig.authUrl,
    realm: "HASHh",
    clientId: "hashh-dashboard",
    onLoad: "login-required",
    KeycloakResponseType: "code",
    scopes: ["openid", "profile"],
  };
  const keycloak = new Keycloak(initOptions);
  const navigate = useHistory();

  //Initiate the keycloack event and it push to the realm of keyclock to authentication
  keycloak
    .init({
      onLoad: initOptions.onLoad,
      KeycloakResponseType: "code",
      checkLoginIframe: false,
      // Keycloak 25+ (staging) only puts the nonce in the ID token, but this
      // keycloak-js version also checks the access and refresh tokens; on a
      // mismatch it clears the token and logs in again, looping forever.
      // PKCE protects the code exchange instead.
      useNonce: false,
      pkceMethod: "S256",
    })
    .then(
      (auth) => {
        if (!auth) {
          window.location.reload();
        } else {
          console.info("Authenticated");
          Keycloaktokens.setToken(keycloak.token);
          Keycloaktokens.setIdToken(keycloak.idToken);
          // The API knows the user by the token's preferred_username; keep it
          // now, so pages can tell the admin account before anything loads.
          if (keycloak.tokenParsed?.preferred_username) User.setUser(keycloak.tokenParsed.preferred_username);

          navigate.push("SelectEcoSystem");
        }
        setTimeout(() => {
          keycloak.updateToken(70).then(
            (refreshed) => {
              if (refreshed) {
                console.debug("Token refreshed" + refreshed);
                Keycloaktokens.setToken(keycloak.token);
                Keycloaktokens.setIdToken(keycloak.idToken);
              } else {
                console.warn(
                  "Token not refreshed, valid for " +
                    Math.round(
                      keycloak.tokenParsed.exp +
                        keycloak.timeSkew -
                        new Date().getTime() / 1000
                    ) +
                    " seconds"
                );
              }
            },
            () => {
              console.error("Authenticated Failed");
            }
          );
        }, 60000);
      },
      () => {
        console.error("Authenticated Failed");
      }
    );

  return <></>;
};
export default Login;
